import React from 'react';
import get_bundle from '../../domain/get_bundle';
import Color from '../../domain/Color';
import { t, props } from 'tcomb-react';

@props({
  locale: t.Obj,
  goProduct: t.maybe(t.Func),
  goCatalog: t.maybe(t.Func),
  goLogin: t.Func,
  color: t.maybe(Color),
  themeBtnColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color)
})
export default class Register extends React.Component {

  getColorStyle() {
    if (!this.props.color) {
      return null;
    }
    return {
      color: this.props.color
    };
  };

  styleBtnColor() {
    return {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };
  };

  goProduct = (evt) => {
    evt.preventDefault();
    this.props.goProduct();
  }

  goCatalog = (evt) => {
    evt.preventDefault();
    this.props.goCatalog();
  }

  goLogin = (evt) => {
    evt.preventDefault();
    this.props.goLogin();
  }

  getGoProductLink() {
    if (!this.props.goProduct) {
      return null;
    }
    //return (<a href='#' id='go_product' style={this.getColorStyle()} onClick={this.goProduct}>{get_bundle(this.props.locale).navigation.go_product}</a>);
    return (<button id='go_product' style={this.styleBtnColor()} onClick={this.goProduct}>{get_bundle(this.props.locale).navigation.go_product}</button>);
  }

  getGoCatalogLink() {
    if (!this.props.goCatalog) {
      return null;
    }

    let style = {
      ...this.styleBtnColor()
    }

    if (this.props.goProduct) {
      style.marginLeft = '20px'
    }

    //return (<a href='#' id='go_catalog' style={this.getColorStyle()} onClick={this.goCatalog}>{get_bundle(this.props.locale).navigation.go_catalog}</a>);
    return (<button id='go_catalog' style={style} onClick={this.goCatalog}>{get_bundle(this.props.locale).navigation.go_catalog}</button>);
  }

  getGoLoginLink() {
    //return (<a href='#' id='go_login' style={this.getColorStyle()}  onClick={this.goLogin}>{get_bundle(this.props.locale).login.title}</a>);
    return (<button id='go_login' style={this.styleBtnColor()}  onClick={this.goLogin}>{get_bundle(this.props.locale).login.title}</button>);
  }

  render() {

    return (
      <div id='header'>
        <div className='cols'>
          <div className='large-70'>
            <div className='cell'>
              {this.getGoProductLink()}
              {this.getGoCatalogLink()}
            </div>
          </div>
          <div className='large-30 large-text-right'>
            <div className='cell'>
               {this.getGoLoginLink()}
            </div>
          </div>
        </div>
      </div>
    );
  }

}






/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/header/Register.js
 **/